export default __webpack_public_path__ + "x-cercle.fb81c8bb.svg";